import { render, staticRenderFns } from "./mainSlider.vue?vue&type=template&id=569bead0&"
import script from "./mainSlider.vue?vue&type=script&lang=js&"
export * from "./mainSlider.vue?vue&type=script&lang=js&"
import style0 from "./mainSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VCard,VCarousel,VCarouselItem,VResponsive})
